const addTitle = (title, header) => {
  header.append('text').attr('class', 'title').text(title.replaceAll('_', ' '))
}

const addLegend = _containerSelector => {}

export { addTitle, addLegend }
